import React from "react";

import { CardElement } from "@stripe/react-stripe-js";
import { Box, Typography } from "@mui/material";

import "./Style.scss";

const LEGACY_CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      innerWidth: "100px",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

const MODERN_CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#0f172a",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "14px",
      lineHeight: "20px",
      "::placeholder": {
        color: "#94a3b8",
      },
    },
    invalid: {
      color: "#dc2626",
      iconColor: "#dc2626",
    },
  },
};

function CardSection({ stripeErr, validateErr, variant = "legacy" }) {
  if (variant === "modern") {
    return (
      <Box className="user-workspace-stripe-card mt-3">
        <Typography
          component="label"
          className="user-workspace-stripe-card__label"
        >
          Card number
        </Typography>
        <Box className="user-workspace-stripe-card__element">
          <CardElement
            id="cardElement"
            options={MODERN_CARD_ELEMENT_OPTIONS}
            onChange={(event) => validateErr(event)}
          />
        </Box>
        {stripeErr ? (
          <Typography className="user-workspace-stripe-card__error">
            {stripeErr}
          </Typography>
        ) : null}
      </Box>
    );
  }

  return (
    <Box className="stripeParent">
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "20px",
          lineHeight: "44px",
          padding: "12px 0 10px",
        }}
      >
        Card details
      </Typography>
      <CardElement
        id="cardElement"
        options={LEGACY_CARD_ELEMENT_OPTIONS}
        onChange={(event) => validateErr(event)}
      />
      {stripeErr ? (
        <p
          className="stripeValidation text-danger m-0 pt-3 fw-400"
          style={{ fontSize: "17px" }}
        >
          {stripeErr}
        </p>
      ) : null}
    </Box>
  );
}

export default CardSection;
